
export default function AppFontAwesomeIcon({
    icon = 'square',
    variant = 's',
    size,
    color,
    className = '',
    ...others
  }) {
    
  return (
    <i
      className={`${className} fa${variant} fa-${icon}`}
      style={{ fontSize: size ? `${size}px` : 'inherit', color }}
      {...others}
    />
  )
}
